import React, { useState, useContext, useEffect, useRef } from "react";
// import { getAuth, updateProfile, signOut } from "firebase/auth";
// import { db } from "../Firebase/FirebaseConfig";
// import {
//   ref,
//   uploadBytesResumable,
//   getDownloadURL,
//   getStorage,
// } from "firebase/storage";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Fade } from "react-reveal";
// import toast, { Toaster } from "react-hot-toast";
import logo from "../../assets/images/mayaLogo.png";
import clsx from 'clsx';

import { AuthContext } from "../../Context/UserContext";
import WelcomePageBanner from "../../assets/images/WelcomePageBanner.png";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { CiCirclePlus } from "react-icons/ci";
import { FaEyeSlash, FaMicrophone, FaMicrophoneSlash } from "react-icons/fa";
import { FaEye } from "react-icons/fa6";

import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axiosClient from "../../axios-client";
import { TbArrowBackUp } from "react-icons/tb";


function EditProfilePassword() {
  const { user, profileId } = useContext(AuthContext);
  const [ErrorMessage, setErrorMessage] = useState("");
  const navigate = useNavigate()
  //password variables
  const [oldPassword, setOldPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');

  const [profile, setProfile] = useState();
  const [loading, setLoading] = useState(true);
  const [isDelete, setIsDelete] = useState(false);
  const location = useLocation()
  const [password, setPassword] = useState("");
  const [modalPassword, setModalPassword] = useState("");
  const [showModal, setShowModal] = useState(false);
  const fetchProfile = async () => {
    try {
      const response = await axiosClient.get(`/profiles/${profileId}/`); // Replace with your API endpoint
      setProfile(response.data);
    } catch (err) {
      // console.error(err);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {


    fetchProfile();
  }, [profileId]);
  // check the password complexity

  const handleFormSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await axiosClient.put(`/change_profile_password/${profileId}/`, {
        old_password: oldPassword,
        new_password: newPassword,
        confirm_password: confirmPassword,
      });
      if (response.data.success) {
        toast.success("le mot de passe est modifié avec succès", {
          position: "top-right",
          autoClose: 3000,
        });

        setConfirmPassword('')
        setNewPassword('')
        setOldPassword('')

      }
      setErrorMessage(response.data.error);
    } catch (err) {
      // console.error(err.response.data.error);
    }
  };
  const deletePassword = async (e) => {
    e.preventDefault();

    try {
      const verifyResponse = await axiosClient.post("verify-password/", {
        user_id: user.id,
        password: modalPassword,
      });
      const response = await axiosClient.put(`/delete-profile-password/${profileId}/`);
      if (response.data.success) {
        toast.success("le mot de passe est supprimé avec succès", {
          position: "top-right",
          autoClose: 3000,
        });

        navigate(-1)

      }
      setErrorMessage(response.data.error);
    } catch (err) {
      // Handle errors
      console.log(err);

      if (err.response && err.response.status === 400) {
        toast.error("Mot de passe incorrect.", {
          position: "top-right",
          autoClose: 3000,
        });
        setModalPassword('')
      } else {
        // Generic error
        // console.error("Failed to update password:", err);
        toast.error("Une erreur s'est produite.", {
          position: "top-right",
          autoClose: 3000,
        });
      }

    }
  };

  const openConfirmModal = () => {
    if (!password || !confirmPassword) {
      setErrorMessage("Veuillez remplir les champs")
      return
    }
    if (password != confirmPassword) {
      setErrorMessage("Le mot de passe et le mot de passe de confirmation ne correspondent pas.")
      return
    }
    setShowModal(true);
  }

  const handleNewPasswordSubmit = async () => {
    try {
      // if (password != confirmPassword) {
      //   setErrorMessage("Le mot de passe et le mot de passe de confirmation ne correspondent pas.")
      //   return
      // }
      const verifyResponse = await axiosClient.post("verify-password/", {
        user_id: user.id,
        password: modalPassword,
      });

      // Send request to the backend to add/update the profile password
      const response = await axiosClient.put(`add-profile-password/${profileId}/`, {
        password: password,
        confirmPassword: confirmPassword,
      });

      // Handle success response
      if (response.data.success) {
        toast.success("Mot de passe ajouté avec succès.", {
          position: "top-right",
          autoClose: 3000,
        });
        setPassword('')
        setConfirmPassword('')
        setErrorMessage('')
        setModalPassword("")
        setShowModal(false)
        fetchProfile()
        // Navigate based on the action
        // if (modalAction === "home") {
        //   setProfileId(selectedProfile);
        //   navigate(`/home`);
        // } else if (modalAction === "edit") {
        //   navigate(`/edit-profile`, {
        //     state: {
        //       profileId: selectedProfile,
        //     },
        //   });
        // }
      }
    } catch (err) {
      // Handle errors
      console.log(err);

      if (err.response && err.response.status === 400) {
        toast.error("Mot de passe incorrect.", {
          position: "top-right",
          autoClose: 3000,
        });
        setModalPassword('')
      } else {
        // Generic error
        // console.error("Failed to update password:", err);
        toast.error("Une erreur s'est produite.", {
          position: "top-right",
          autoClose: 3000,
        });
      }

      // Reset the password fields
      setPassword("");
      setConfirmPassword("");
    }
  };
  return (
    <section
      className="py-10 px-3  min-h-[100vh] flex-col flex items-center justify-center relative"  // Ensures the section takes the full height and centers content
      style={{
        background: `url(${WelcomePageBanner})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundAttachment: "fixed",
      }}
    >
      <ToastContainer />
      <Link
        onClick={() => navigate(-1)}
        className="absolute top-2 left-2 flex items-center justify-center bg-black/20 rounded-full p-2.5 cursor-pointer"
        title="Se déconnecter"
      >
        <TbArrowBackUp size={"26px"} className="text-orange-500" />
      </Link>
      <div className="pb-5 flex justify-center items-center ">
        <img
          className="h-10 cursor-pointer w-18"
          src={logo}
          alt="Mayaplus"
        />
      </div>
      {profile?.password ?
        <>
          <div className="w-full bg-white/5 max-w-sm backdrop-blur-md p-5 md:p-10 rounded-lg">

            <h1 className=" text-center text-xl text-white  mb-4 md:mb-8">
              Modifier le mot de passe de profil
            </h1>
            <form className="space-y-4 md:space-y-6 ">
              {ErrorMessage && (
                <h1 className="flex text-sm text-white p-3 bg-red-500 rounded ">

                  {ErrorMessage}
                </h1>
              )}
              <div>

                <input
                  type="password"
                  name="Oldpassword"
                  id="Oldpassword"
                  placeholder="Mot de passe actuel"
                  className={"bg-white/10 backdrop-blur text-white sm:text-md rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-3.5 dark:text-gray dark:focus:ring-blue-500 dark:focus:border-blue-500 placeholder:text-gray"}
                  required=""
                  value={oldPassword}
                  onChange={(e) => setOldPassword(e.target.value)}
                ></input>
              </div>
              <div>

                <input
                  type="password"
                  name="Newpassword"
                  id="Newpassword"
                  placeholder="Nouveau mot de passe"
                  className={"bg-white/10 backdrop-blur text-white sm:text-md rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-3.5 dark:text-gray dark:focus:ring-blue-500 dark:focus:border-blue-500 placeholder:text-gray"}
                  value={newPassword}
                  required=""
                  onChange={(e) => setNewPassword(e.target.value)}
                  onCopy={(e) => e.preventDefault()}
                ></input>
              </div>

              <div>

                <input
                  type="password"
                  name="Confirmpassword"
                  id="Confirmpassword"
                  placeholder="Confirmer mot de passe"
                  className={"bg-white/10 backdrop-blur text-white sm:text-md rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-3.5 dark:text-gray dark:focus:ring-blue-500 dark:focus:border-blue-500 placeholder:text-gray"}
                  value={confirmPassword}
                  required=""
                  onChange={(e) => setConfirmPassword(e.target.value)}
                ></input>
              </div>
            </form>
          </div>
          <div className="w-[100%] mt-5 flex items-center justify-center">
            <Link >
              <button onClick={handleFormSubmit} style={{
                background: "linear-gradient(to right, #2ea7a9, #72c9cb)",
              }} className=" lg:w-[100%] px-14 py-3 mt-3 font-medium text-white rounded-md md:text-md flex items-center justify-center ">
                Sauvegarder
              </button>

            </Link>
          </div>
          <div className="w-[100% flex items-center justify-center">
            <Link onClick={() => {
              setShowModal(true);
              setIsDelete(true)
            }}>
              <h1 className=" text-center text-sm hover:underline font-semibold leading-tight tracking-tight py-5 text-red-400">
                Supprimer le mot de passe
              </h1>

            </Link>
          </div>
        </>
        :
        <div className="w-full bg-white/5 max-w-sm backdrop-blur-md p-5 md:p-10 rounded-lg">
          <h1 className=" text-center text-xl text-white  mb-4 md:mb-8">
            Ajouter un mot de passe de profil </h1>
          <form className="space-y-4 md:space-y-6 ">
            {ErrorMessage && (
              <h1 className="flex text-sm text-white p-3 mb-3 bg-red-500 rounded ">

                {ErrorMessage}
              </h1>
            )}
            <div>

              <input
                type="password"
                name="password"
                id="password"
                placeholder="Mot de passe"
                className={"bg-white/10 backdrop-blur text-white sm:text-md rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-3.5 dark:text-gray dark:focus:ring-blue-500 dark:focus:border-blue-500 placeholder:text-gray"}
                required=""
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              ></input>
            </div>
            {/* <input
type="password"
placeholder="Mot de passe"
value={password}
onChange={(e) => setPassword(e.target.value)}
className="w-full border border-gray-300 rounded-md px-3 py-2 mb-4 focus:outline-none focus:ring-1 focus:ring-gray-200"
/> */}
            <div>

              <input
                type="password"
                name="Confirmpassword"
                id="Confirmpassword"
                placeholder="Confirmer votre mot de passe"
                className={"bg-white/10 backdrop-blur text-white sm:text-md rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-3.5 dark:text-gray dark:focus:ring-blue-500 dark:focus:border-blue-500 placeholder:text-gray"}
                value={confirmPassword}
                required=""
                onChange={(e) => setConfirmPassword(e.target.value)}
                onCopy={(e) => e.preventDefault()}
              ></input>
            </div>
            {/* <input
type="password"
placeholder="Confirmer votre mot de passe"
value={confirmPassword}
onChange={(e) => setConfirmPassword(e.target.value)}
className="w-full border border-gray-300 rounded-md px-3 py-2 mb-4 focus:outline-none focus:ring-1 focus:ring-gray-200"
/> */}
            <div className="w-[100%] mt-5 flex items-center justify-center">
              <Link >
                <button
                  // onClick={handleNewPasswordSubmit} 
                  onClick={openConfirmModal
                  }
                  disabled={!password || !confirmPassword}
                  style={{
                    background: "linear-gradient(to right, #2ea7a9, #72c9cb)",
                  }} className=" lg:w-[100%] px-14 py-3 mt-3 font-medium text-white rounded-md md:text-md flex items-center justify-center ">
                  Sauvegarder
                </button>

              </Link>
            </div>
          </form>


        </div>
      }
      {showModal && (
        <div
          id="medium-modal"
          tabIndex="-1"
          className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50"
        >
          <div className="bg-white p-6 rounded-lg shadow-lg w-96">
            {/* Modal header */}
            <h2 className="text-lg font-semibold mb-4">Entrer le mot de passe de compte</h2>

            {/* Modal body */}
            <p className="text-sm text-gray-500 mb-4">
              Veuillez entrer le mot de passe de compte pour affecter un mot de passe a ce profil.
            </p>
            <input
              type="password"
              placeholder="Mot de passe"
              value={modalPassword}
              onChange={(e) => setModalPassword(e.target.value)}
              className="w-full border border-gray-300 rounded-md px-3 py-2 mb-4 focus:outline-none focus:ring-1 focus:ring-gray-200"
            />

            {/* Modal footer */}
            <div className="flex justify-end gap-3">
              <button
                onClick={() => {
                  setShowModal(false)
                  setModalPassword("")
                }} // Close modal
                className="px-4 py-2 bg-gray-500 text-white rounded-md hover:bg-gray-600"
              >
                Annuler
              </button>
              {isDelete ?
                <button
                  onClick={deletePassword} // Handle delete
                  className={`px-4 py-2 bg-red-500 text-white rounded-md hover:bg-red-600 ${loading ? "opacity-50 cursor-not-allowed" : ""
                    }`}
                  disabled={!modalPassword.trim() || loading} // Disable button if no password or loading
                >
                  {loading ? "Suppression..." : "Supprimer"}
                </button>
                :
                <button
                  onClick={handleNewPasswordSubmit} // Handle delete
                  className={`px-4 py-2 bg-red-500 text-white rounded-md hover:bg-red-600 ${loading ? "opacity-50 cursor-not-allowed" : ""
                    }`}
                  disabled={!modalPassword.trim() || loading} // Disable button if no password or loading
                >
                  {loading ? "Confirmation..." : "Confirmer"}
                </button>}

            </div>
          </div>
        </div>

      )}
    </section>
  );
}

export default EditProfilePassword;
